import React from "react";
import { Select as AntSelect } from "antd";
export default function Select({
  value,
  field,
  options = [],
  onChange,
  placeholder,
  opts = {},
}) {
  return (
    <AntSelect
      allowClear
      name={field}
      value={value || undefined}
      placeholder={placeholder || "请选择"}
      onChange={onChange}
      style={{ width: "100%" }}
      onSearch={opts.showSearch && onChange}
      {...opts}
    >
      {options.map((item) => (
        <AntSelect.Option
          key={item.id}
          value={item.id}
          disabled={!!item.disabled}
        >
          {item.name}
        </AntSelect.Option>
      ))}
    </AntSelect>
  );
}
